import React from "react";
import { Modal, Tag, Card, Row, Col, Divider } from "antd";
import { Table } from "react-bootstrap";
import moment from "moment";

function DetailsMoal(props) {
  let TotalAmount =
    props.item.boxes &&
    props.item.boxes.reduce(function (tot, arr) {
      return Number(tot) + Number(arr?.total_charge);
    }, 0);

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case "paid": return "#52c41a";
      case "partial": return "#faad14";
      case "unpaid": return "#f5222d";
      case "approve": return "#52c41a";
      case "process": return "#1890ff";
      case "pending": return "#d9d9d9";
      default: return "#d9d9d9";
    }
  };

  return (
    <Modal
      visible={props.visible}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
      width={1200}
      footer={null}
      title={<span style={{ fontSize: "18px", fontWeight: "600" }}>Collection Details</span>}
    >
      <div style={{ padding: "10px" }}>
        {/* Payment Summary Cards */}
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col xs={24} sm={12} md={6}>
            <Card size="small" style={{ textAlign: "center", backgroundColor: "#e3f2fd", border: "none" }}>
              <div style={{ fontSize: "12px", color: "#666" }}>Total Amount</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#1976d2" }}>
                {TotalAmount || 0}
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card size="small" style={{ textAlign: "center", backgroundColor: "#fff3e0", border: "none" }}>
              <div style={{ fontSize: "12px", color: "#666" }}>Discount</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#f57c00" }}>
                {props.item?.discount || 0}
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card size="small" style={{ textAlign: "center", backgroundColor: "#e8f5e9", border: "none" }}>
              <div style={{ fontSize: "12px", color: "#666" }}>Paid Amount</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#388e3c" }}>
                {props.item?.paid_amount || 0}
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card size="small" style={{ textAlign: "center", backgroundColor: "#ffebee", border: "none" }}>
              <div style={{ fontSize: "12px", color: "#666" }}>Balance</div>
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#d32f2f" }}>
                {props.item?.balance || 0}
              </div>
            </Card>
          </Col>
        </Row>

        {/* Collection Info */}
        <Card
          size="small"
          title={<span style={{ color: "#1e88e5" }}>Collection Information</span>}
          style={{ marginBottom: "16px" }}
        >
          <Row gutter={[16, 8]}>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Total Weight:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.total_weight || "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Payment Mode:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.payment_mode || "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Collected By:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.collected_user?.name || "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Collected Date:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.collected_datetime ? moment(props.item.collected_datetime).format("DD/MM/YYYY hh:mm A") : "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Updated By:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.updated_user?.name || "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Agent Name:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.agent?.user?.name || "-"}</b></Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Third Party:</span></Col>
            <Col xs={12} md={6}>
              <Tag color={props.item?.is_third_party_collection ? "orange" : "green"}>
                {props.item?.is_third_party_collection ? "Yes" : "No"}
              </Tag>
            </Col>
            <Col xs={12} md={6}><span style={{ color: "#888" }}>Last Updated:</span></Col>
            <Col xs={12} md={6}><b>{props.item?.updatedat ? moment(props.item.updatedat).format("DD/MM/YYYY hh:mm A") : "-"}</b></Col>
            <Col xs={24} md={6}><span style={{ color: "#888" }}>Instructions:</span></Col>
            <Col xs={24} md={18}><b>{props.item?.instructions || "-"}</b></Col>
          </Row>
        </Card>

        {/* Sender & Receiver Details */}
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col xs={24} md={12}>
            <Card
              size="small"
              title={<span style={{ color: "#1e88e5" }}>Sender Details</span>}
              style={{ height: "100%" }}
            >
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Name:</span>
                <b>{props.item?.sender_name || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Phone:</span>
                <b>{props.item?.sender_phone || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Alt. Phone:</span>
                <b>{props.item?.sender_phone_alt || "-"}</b>
              </div>
              <div>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Address:</span>
                <b>{props.item?.sender_address || "-"}</b>
              </div>
            </Card>
          </Col>
          <Col xs={24} md={12}>
            <Card
              size="small"
              title={<span style={{ color: "#1e88e5" }}>Receiver Details</span>}
              style={{ height: "100%" }}
            >
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Name:</span>
                <b>{props.item?.reciver_name || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Phone:</span>
                <b>{props.item?.reciver_phone || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Alt. Phone:</span>
                <b>{props.item?.reciver_altphone || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Address:</span>
                <b>{props.item?.reciver_address || "-"}</b>
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Pincode:</span>
                <b>{props.item?.reciver_pincode || "-"}</b>
              </div>
              <div>
                <span style={{ color: "#888", display: "inline-block", width: "100px" }}>Country:</span>
                <b>{props.item?.reciver_countries?.name || "-"}</b>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Payment History */}
        <Card
          size="small"
          title={<span style={{ color: "#52c41a" }}>Payment History</span>}
          style={{ marginBottom: "16px" }}
        >
          {props.item?.ledgerTransColln && props.item.ledgerTransColln.length > 0 ? (
            <Table striped bordered hover size="sm" style={{ marginBottom: 0 }}>
              <thead style={{ backgroundColor: "#f5f5f5" }}>
                <tr>
                  <th style={{ padding: "10px", textAlign: "center" }}>#</th>
                  <th style={{ padding: "10px" }}>Date</th>
                  <th style={{ padding: "10px" }}>Payment Mode</th>
                  <th style={{ padding: "10px", textAlign: "right" }}>Amount</th>
                  <th style={{ padding: "10px", textAlign: "right" }}>Discount</th>
                  <th style={{ padding: "10px" }}>User</th>
                  <th style={{ padding: "10px" }}>Note</th>
                </tr>
              </thead>
              <tbody>
                {props.item?.ledgerTransColln
                  ?.filter((payment) => payment?.payment_mode)
                  ?.map((payment, idx) => (
                  <tr key={idx}>
                    <td style={{ padding: "10px", textAlign: "center" }}>{idx + 1}</td>
                    <td style={{ padding: "10px" }}>
                      {payment?.payment_date ? moment(payment?.payment_date).format("DD/MM/YYYY") : "-"}
                    </td>
                    <td style={{ padding: "10px" }}>
                      <Tag color={payment?.payment_mode === "cash" ? "green" : "blue"}>
                        {payment?.payment_mode?.toUpperCase() || "-"}
                      </Tag>
                    </td>
                    <td style={{ padding: "10px", textAlign: "right", fontWeight: "bold", color: "#388e3c" }}>
                      {payment?.amount || 0}
                    </td>
                    <td style={{ padding: "10px", textAlign: "right", fontWeight: "bold", color: "#f57c00" }}>
                      {payment?.box_discount || 0}
                    </td>
                    <td style={{ padding: "10px" }}>{payment?.user?.name || "-"}</td>
                    <td style={{ padding: "10px" }}>{payment?.note || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div style={{ textAlign: "center", padding: "20px", color: "#999" }}>
              No payment records found
            </div>
          )}
        </Card>

        {/* Box Details */}
        <Card
          size="small"
          title={<span style={{ color: "#1e88e5" }}>Box Details ({props.item?.boxes?.length || 0} Boxes)</span>}
        >
          {props.item.boxes &&
            props.item.boxes.length > 0 &&
            props.item.boxes.map((box, index) => (
              <Card
                key={index}
                size="small"
                style={{ marginBottom: "16px", border: "1px solid #e0e0e0" }}
                title={
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ color: "#1976d2", fontWeight: "bold" }}>
                      Box {index + 1}: {box.box_number}
                    </span>
                    <Tag color={getPaymentStatusColor(box.paid_status)}>
                      {(box.paid_status || "unpaid").toUpperCase()}
                    </Tag>
                  </div>
                }
              >
                {/* Box Dimensions & Info */}
                <Row gutter={[8, 8]} style={{ marginBottom: "12px" }}>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Service Type</div>
                      <div style={{ fontWeight: "bold" }}>{box.service_type || "-"}</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Size</div>
                      <div style={{ fontWeight: "bold" }}>{box.size || "-"}</div>
                    </div>
                  </Col>
                  <Col xs={8} sm={4} md={2}>
                    <div style={{ backgroundColor: "#e3f2fd", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>L</div>
                      <div style={{ fontWeight: "bold" }}>{box.length || 0}</div>
                    </div>
                  </Col>
                  <Col xs={8} sm={4} md={2}>
                    <div style={{ backgroundColor: "#e3f2fd", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>B</div>
                      <div style={{ fontWeight: "bold" }}>{box.breadth || 0}</div>
                    </div>
                  </Col>
                  <Col xs={8} sm={4} md={2}>
                    <div style={{ backgroundColor: "#e3f2fd", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>H</div>
                      <div style={{ fontWeight: "bold" }}>{box.height || 0}</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div style={{ backgroundColor: "#e8f5e9", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Actual Weight</div>
                      <div style={{ fontWeight: "bold" }}>{box.weight || 0} KG</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div style={{ backgroundColor: "#e8f5e9", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Volume Weight</div>
                      <div style={{ fontWeight: "bold" }}>{box.volume_weight || 0} KG</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div style={{ backgroundColor: "#fff8e1", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Chargeable Weight</div>
                      <div style={{ fontWeight: "bold", color: "#f57c00" }}>{box.chargable_weight || 0} KG</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div style={{ backgroundColor: "#fce4ec", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Adj. Weight</div>
                      <div style={{ fontWeight: "bold", color: "#c2185b" }}>{box.adjustment_weight ? `${box.adjustment_weight} KG` : "-"}</div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6} md={3}>
                    <div style={{ backgroundColor: "#fff3e0", padding: "8px", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#888" }}>Rate/KG</div>
                      <div style={{ fontWeight: "bold" }}>{box.rate || 0}</div>
                    </div>
                  </Col>
                </Row>

                {/* Box Charges */}
                <Divider style={{ margin: "12px 0", fontSize: "13px" }}>Charges</Divider>
                <Row gutter={[8, 8]} style={{ marginBottom: "12px" }}>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#fafafa", borderRadius: "4px" }}>
                      <span style={{ color: "#888", fontSize: "12px" }}>Packing: </span>
                      <b>{box.packing_charge || 0}</b>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#fafafa", borderRadius: "4px" }}>
                      <span style={{ color: "#888", fontSize: "12px" }}>Duty: </span>
                      <b>{box.duty || 0}</b>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#fafafa", borderRadius: "4px" }}>
                      <span style={{ color: "#888", fontSize: "12px" }}>Other: </span>
                      <b>{box.other_charges || 0}</b>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#e8f5e9", borderRadius: "4px" }}>
                      <span style={{ color: "#388e3c", fontSize: "12px" }}>Total: </span>
                      <b style={{ color: "#388e3c" }}>{box.total_charge || 0}</b>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#fafafa", borderRadius: "4px" }}>
                      <span style={{ color: "#888", fontSize: "12px" }}>Value: </span>
                      <b>{box.total_value || 0}</b>
                    </div>
                  </Col>
                  <Col xs={12} sm={8} md={4}>
                    <div style={{ padding: "6px 10px", backgroundColor: "#fafafa", borderRadius: "4px" }}>
                      <span style={{ color: "#888", fontSize: "12px" }}>USD: </span>
                      <b>${box.total_value_usd || 0}</b>
                    </div>
                  </Col>
                </Row>

                {/* Box Payment Info */}
                <Divider style={{ margin: "12px 0", fontSize: "13px" }}>Payment Info</Divider>
                <Row gutter={[16, 8]}>
                  <Col xs={12} sm={6}>
                    <div style={{ padding: "10px", backgroundColor: "#e8f5e9", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#666" }}>Paid Amount</div>
                      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#388e3c" }}>
                        {box.box_paid_amount || 0}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div style={{ padding: "10px", backgroundColor: "#fff3e0", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#666" }}>Box Discount</div>
                      <div style={{ fontSize: "18px", fontWeight: "bold", color: "#f57c00" }}>
                        {box.box_discount || 0}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div style={{ padding: "10px", backgroundColor: ((box.total_charge || 0) - (box.box_paid_amount || 0) - (box.box_discount || 0)) > 0 ? "#ffebee" : "#e8f5e9", borderRadius: "4px", textAlign: "center" }}>
                      <div style={{ fontSize: "11px", color: "#666" }}>Balance</div>
                      <div style={{ fontSize: "18px", fontWeight: "bold", color: ((box.total_charge || 0) - (box.box_paid_amount || 0) - (box.box_discount || 0)) > 0 ? "#d32f2f" : "#388e3c" }}>
                        {((box.total_charge || 0) - (box.box_paid_amount || 0) - (box.box_discount || 0)).toFixed(2)}
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div style={{ padding: "10px", backgroundColor: "#f5f5f5", borderRadius: "4px", textAlign: "center", height: "100%" }}>
                      <span style={{ marginRight: "10px" }}>
                        {box.staff_paid ? (
                          <Tag color="blue">Staff Paid</Tag>
                        ) : null}
                      </span>
                      <span>
                        {box.customer_paid ? (
                          <Tag color="green">Customer Paid</Tag>
                        ) : null}
                      </span>
                      {!box.staff_paid && !box.customer_paid && (
                        <span style={{ color: "#999", fontSize: "12px" }}>No payment flags</span>
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Box Items */}
                {box.boxitems && box.boxitems.length > 0 && (
                  <>
                    <Divider style={{ margin: "12px 0", fontSize: "13px" }}>Items ({box.boxitems.length})</Divider>
                    <Table striped bordered hover size="sm" style={{ marginBottom: 0 }}>
                      <thead style={{ backgroundColor: "#f5f5f5" }}>
                        <tr>
                          <th style={{ padding: "8px", textAlign: "center", width: "50px" }}>#</th>
                          <th style={{ padding: "8px" }}>Item</th>
                          <th style={{ padding: "8px", textAlign: "center" }}>Qty</th>
                          <th style={{ padding: "8px", textAlign: "right" }}>Value</th>
                          <th style={{ padding: "8px" }}>Brand</th>
                        </tr>
                      </thead>
                      <tbody>
                        {box.boxitems.map((item, itemIndex) => (
                          <tr key={itemIndex}>
                            <td style={{ padding: "8px", textAlign: "center" }}>{itemIndex + 1}</td>
                            <td style={{ padding: "8px" }}>{item?.item || "-"}</td>
                            <td style={{ padding: "8px", textAlign: "center" }}>{item?.quantity || 0}</td>
                            <td style={{ padding: "8px", textAlign: "right" }}>{item?.value || 0}</td>
                            <td style={{ padding: "8px" }}>{item?.brand || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                )}
              </Card>
            ))}
        </Card>

      </div>
    </Modal>
  );
}

export default DetailsMoal;
